const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/registrationStatus.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

// FIXME: Nothing dispatches this action
export const REQUEST_ACTION_TYPES_CHECK_REGISTRATION_STATUS = kisapiActionTypes('PATAPP_LOAD_CHECK_REGISTRATIONSTATUS');
